import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ControlsChildBaseComponent} from '../base/controls-child-base.component';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../app/app.state';
import {AsideService} from '../../../../core/services/aside.service';
import {UrlService} from '../../../../core/services/url.service';
import {TitleBreadcrumbsChangedAction, TitleChangedAction} from '../../../../core/actions/title.actions';
import {SubnavComponent, SubnavItem} from '../../../components/subnav/subnav.component';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'motn-controls-hubs',
  templateUrl: './controls-hubs.component.html',
  styleUrls: ['./controls-hubs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SubnavComponent,
    RouterOutlet,
  ],
})
export class ControlsHubsComponent extends ControlsChildBaseComponent implements OnInit, OnDestroy {
  subnavItems: SubnavItem[];


  constructor(
    protected store: Store<AppState>,
    protected asideService: AsideService,
    protected urlService: UrlService,
  ) {
    super(store, asideService, urlService);

    this.subnavItems = [
      {
        text: 'My Hubs',
        href: UrlService.controlsUrls.hubsExisting,
      },
      {
        text: 'Add Hubs',
        href: UrlService.controlsUrls.hubsNew,
      },
    ];
  }


  protected onInit(): void {
  }


  protected onDestroy(): void {
  }


  protected updateTitle() {
    this.store.dispatch(new TitleChangedAction(
      '',
      'Hubs',
      [{
        text: 'Loading...',
      }],
    ));

    this.store.dispatch(new TitleBreadcrumbsChangedAction(
      [{
        path: UrlService.controlsUrls.dashboard,
        text: 'Controls',
      }, {
        text: 'Hubs',
        icon: 'square-h',
      }],
    ));
  }
}
